/*
 *   File : profile.js
 *   Author : https://evoqins.com
 *   Description : Profile detail tab file
 *   Integrations : NA
 *   Version : 1.0.0
*/

// custom packages
import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { Chip, Loader } from '../../../Components/Others';
import { SecondaryButton, TextButton } from '../../../Components/Buttons';
import { APIService } from '../../../Service';
import { toast } from 'react-toastify';
import { Modal } from 'bootstrap';
import CheckStatusModal from '../../../Components/Modal/check-status';

const Profile = (props) => {
    const location = useLocation();
    const { id } = useParams();

    const [checkStatus, setCheckStatus] = useState(false);
    const [kycStatusData, setKycStatusData] = useState(null);
    const [checkStatusLoader, setCheckStatusLoader] = useState(false);

    useEffect(() => {
        if (checkStatus === true) {
            const el = document.getElementById("check-status-modal");
            if (el) {
                const modal = new Modal(el);
                modal.show();
            }
        }
    }, [checkStatus]);

    // API - Check customer status
    const _checkCustomerStatus = () => {

        let is_post = true;
        let url = 'non-kyc-user/check-kyc-status';
        let request = {
            customer_ids: [id]
        }

        setCheckStatusLoader(true);

        APIService(is_post, url, request).then((response) => {
            if (response?.status_code === 200) {
                setKycStatusData(response.data[0]?.cvl_data ?? null);
                setCheckStatus(true);
            } else {
                toast.dismiss();
                toast.error(response?.message || 'Unable to check KYC status. Please try again.', { type: 'error' });
            }
        }).finally(() => {
            setCheckStatusLoader(false);
        });
    };


    return (
        <div className='d-flex flex-column gap-4 padding-32px-all'>
            {/* Profile details */}
            <div>
                <h6 className='mb-3 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                    Profile details
                </h6>

                <div className='e-bg-magnolia border-radius-8 p-3 '>
                    <div className='row pb-4'>
                        <div className='col-4'>
                            <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                Full name
                            </p>
                            <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                {props.data.profile.name}
                            </p>
                        </div>
                        <div className='col-4'>
                            <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                DOB
                            </p>
                            <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                {props.data.profile.dob === null ? "-" : props.data.profile.dob}
                            </p>
                        </div>
                        <div className='col-4'>
                            <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                Gender
                            </p>
                            <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                {props.data.profile.gender === null ? "-" : props.data.profile.gender}
                            </p>
                        </div>
                    </div>

                    <div className='row pb-4'>
                        <div className='col-4'>
                            <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                Marital status
                            </p>
                            <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                {props.data.profile.marital_status === null ? "-" : props.data.profile.marital_status}
                            </p>
                        </div>
                        <div className='col-4'>
                            <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                Email
                            </p>
                            <a href={`mailto:${props.data.profile.email}`} target='_blank' className={`${location.pathname.includes("support") ? "pe-none" : ""} mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px text-decoration-none text-decoration-hover-underline`}>
                                {props.data.profile.email}
                            </a>
                        </div>
                        <div className='col-4'>
                            <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                Phone number
                            </p>
                            <a href={`tel:${props.data.profile.phone}`} className={`${location.pathname.includes("support") ? "pe-none" : ""} mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px text-decoration-none text-decoration-hover-underline`}>
                                {props.data.profile.phone}
                            </a>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-4'>
                            <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                Occupation
                            </p>
                            <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                {props.data.profile.occupation === null ? "-" : props.data.profile.occupation}
                            </p>
                        </div>
                        <div className='col-4'>
                            <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                Source of income
                            </p>
                            <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                {props.data.profile.income_source === null ? "-" : props.data.profile.income_source}
                            </p>
                        </div>
                        <div className='col-4'>
                            <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                Political exposed
                            </p>
                            <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                {props.data.profile.pep ? props.data.profile.pep : "-"}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* KYC details */}
            <div>
                <h6 className='mb-3 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                    KYC details
                </h6>

                <div className='e-bg-magnolia border-radius-8 p-3'>
                    <div className='row pb-4'>
                        <div className='col-4'>
                            <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                PAN
                            </p>
                            <div className='d-flex align-items-center gap-2 flex-wrap'>
                                <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                    {props.data.kyc_details.pan === null ? "-" : props.data.kyc_details.pan}
                                </p>
                                {props.data?.kyc_details?.pan !== null && props.data?.kyc_details?.pan !== "N/A" &&
                                    <div className='position-relative'>
                                        <TextButton
                                            name="KYC Status"
                                            fontSize="e-font-12"
                                            disabled={checkStatusLoader}
                                            onClick={_checkCustomerStatus}
                                        />
                                        {checkStatusLoader ?
                                            <Loader className="position-absolute top--6px right--30px"
                                                width={32}
                                                height={32} /> : null
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                        <div className='col-4'>
                            <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                Nationality
                            </p>
                            <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                {props.data.kyc_details.citizenship || "-"}
                            </p>
                        </div>

                        <div className='col-4'>
                            <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                Country of birth
                            </p>
                            <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                {props.data.profile?.country_of_birth || "-"}
                            </p>
                        </div>

                    </div>

                    <div className='row pb-4'>
                        <div className='col-4'>
                            <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                Place of birth
                            </p>
                            <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                {props.data?.profile?.place_of_birth_city || "-"}
                            </p>
                        </div>

                        <div className='col-4'>
                            <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                State
                            </p>
                            <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                {props.data.kyc_details.state === null ? "-" : props.data.kyc_details.state}
                            </p>
                        </div>
                        <div className='col-4'>
                            <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                City
                            </p>
                            <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                {props.data.kyc_details.city || "-"}
                            </p>
                        </div>
                    </div>

                    <div className='row row-gap-4'>



                        {props.data.profile?.resident_type === "NRI" &&
                            <>
                                <div className='col-4'>
                                    <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                        TIN
                                    </p>
                                    <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                        {props.data.profile?.tin || "-"}
                                    </p>
                                </div>
                                <div className='col-4'>
                                    <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                        Tax residency from date
                                    </p>
                                    <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                        {props.data.profile?.tax_residency_from_date || "-"}
                                    </p>
                                </div>

                                <div className='col-4'>
                                    <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                        Tax residency to date
                                    </p>
                                    <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                        {props.data.profile?.tax_residency_to_date || "-"}
                                    </p>
                                </div>

                            </>
                        }

                        <div className='col-4'>
                            <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                Permanent address
                            </p>
                            <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-20px'>
                                {
                                    (() => {
                                        const updated_address = props.data?.kyc_details?.permanent_address;
                                        if (!updated_address || Object.keys(updated_address).length === 0) {
                                            return "-";
                                        }

                                        const parts = [
                                            `${updated_address.address_line1 || ""} ${updated_address.address_line2 || ""}`.trim(),
                                            updated_address.city || "",
                                            updated_address.state || "",
                                            updated_address.pincode || ""
                                        ];

                                        return parts.filter(Boolean).join(", ");
                                    })()
                                }
                            </p>
                        </div>
                        {props.data.kyc_details.is_same_corresponding_address === false &&
                            <div className='col-4'>
                                <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                    Communication address
                                </p>
                                <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-20px'>
                                    {
                                        (() => {
                                            const updated_address = props.data?.kyc_details?.correspondence_address;
                                            if (!updated_address || Object.keys(updated_address).length === 0) return "-";

                                            const parts = [
                                                `${updated_address.address_line1 || ""} ${updated_address.address_line2 || ""}`.trim(),
                                                updated_address.city || "",
                                                updated_address.state || "",
                                                updated_address.pincode || ""
                                            ];

                                            return parts.filter(Boolean).join(", ");
                                        })()
                                    }
                                </p>
                            </div>
                        }
                    </div>
                </div>
            </div>

            {/* Bank details  */}
            <div>
                <h6 className='mb-3 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                    Bank details
                </h6>

                {props.data.all_banks.length !== 0 ?

                    <div className='d-flex flex-column gap-2'>
                        {props.data.all_banks.map((bank, index) => (
                            <div key={index} className='e-bg-magnolia border-radius-8 p-3'>

                                <div className='d-flex align-items-center gap-2 justify-content-between'>
                                    {bank.is_default === true ?
                                        <div className='mb-2'>
                                            < Chip label={"Primary"}
                                                tooltip={false}
                                                textAlign="justify-content-start"
                                                className={"e-bg-magnolia-extra-light e-text-blue-violet "} />
                                        </div>
                                        :
                                        <div className='mb-2'>
                                            < Chip label={"Secondary"}
                                                tooltip={false}
                                                textAlign="justify-content-start"
                                                className={"e-bg-magnolia-extra-light e-text-blue-violet "} />
                                        </div>
                                    }

                                    {bank.verification_status &&
                                        <div className='mb-2'>
                                            <Chip label={bank.verification_status}
                                                tooltip={false}
                                                textAlign="justify-content-start"
                                                className={`${bank.verification_status?.toLowerCase() === "verified" ? " e-bg-light-green " :
                                                    bank.verification_status?.toLowerCase() === "pending" ? "e-bg-light-beige" :
                                                        "e-bg-pale-pink "}  text-capitalize e-text-dark-gray`} />
                                        </div>
                                    }
                                </div>
                                <div className='row pb-4'>
                                    <div className='col-4'>
                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                            Account number
                                        </p>
                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                            {bank.account_number === null ? "-" : bank.account_number}
                                        </p>
                                    </div>
                                    <div className='col-4'>
                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                            Account holder name
                                        </p>
                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                            {bank.account_holder === null ? "-" : bank.account_holder}
                                        </p>
                                    </div>
                                    <div className='col-4'>
                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                            Account type
                                        </p>
                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                            {bank.account_type === null ? "-" : bank.account_type}
                                        </p>
                                    </div>
                                </div>

                                <div className='row pb-4'>
                                    <div className='col-4'>
                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                            Bank name
                                        </p>
                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                            {bank.name === null ? "-" : bank.name}
                                        </p>
                                    </div>
                                    <div className='col-4'>
                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                            IFSC code
                                        </p>
                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                            {bank.ifsc === null ? "-" : bank.ifsc}
                                        </p>
                                    </div>
                                    <div className='col-4'>
                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                            Joint account
                                        </p>
                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                            {bank.is_joint_account === null ? "-" : bank.is_joint_account === true ? "Yes" : "No"}
                                        </p>
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className='col-4'>
                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                            Created at
                                        </p>
                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                            {bank.created_at || "-"}
                                        </p>
                                    </div>
                                    <div className='col-4'>
                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                            Failed at
                                        </p>
                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                            {bank.failed_at || "-"}
                                        </p>
                                    </div>
                                    <div className='col-4'>
                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                            Failed reason
                                        </p>
                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                            {bank.failure_reason || "-"}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    :
                    <div className='e-bg-magnolia border-radius-8 p-5'>
                        <div className='row  '>
                            <div className='justify-content-center  align-items-center d-flex e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>No data found</div>
                        </div>
                    </div>
                }
            </div>


            {/* Nominee details */}
            <div>
                <h6 className='mb-3 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                    Nominee details
                </h6>

                {props.data?.nominee?.length > 0 ?

                    <div className='d-flex flex-column gap-2'>
                        {
                            props.data?.nominee && props.data?.nominee?.map((nominee) => (
                                <div className='e-bg-magnolia border-radius-8 p-3'>
                                    <div className='row pb-4'>
                                        <div className='col-4'>
                                            <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                Nominee name
                                            </p>
                                            <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>

                                                {nominee.name || "-"}
                                            </p>
                                        </div>
                                        <div className='col-4'>
                                            <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                Allocation
                                            </p>
                                            <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>

                                                {nominee.allocation || '-'}
                                            </p>
                                        </div>
                                        <div className='col-4'>
                                            <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                DOB
                                            </p>
                                            <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>

                                                {nominee.dob || "-"}
                                            </p>
                                        </div>
                                    </div>

                                    <div className='row row-gap-4'>
                                        <div className='col-4'>
                                            <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                Relation
                                            </p>
                                            <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>

                                                {nominee.relation || "-"}
                                            </p>
                                        </div>

                                        {nominee.minor === true ?
                                            <>
                                                <div className='col-4'>
                                                    <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                        Guardian name
                                                    </p>
                                                    <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                        {nominee.guardian_name || "-"}
                                                    </p>
                                                </div>

                                                <div className='col-4'>
                                                    <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                        Guardian relation
                                                    </p>
                                                    <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                        {nominee.guardian_relationship || "-"}
                                                    </p>
                                                </div>

                                                <div className='col-4'>
                                                    <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                        Guardian {nominee.guardian_id_proof_type === 353 ? "pan" :
                                                            nominee.guardian_id_proof_type === 354 ? "passport" : nominee.guardian_id_proof_type === 355 ? "aadhar" : nominee.guardian_id_proof_type === 356 ? "driving license" : "proof"}
                                                    </p>
                                                    <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>

                                                        {nominee.guardian_id_proof_number || "-"}
                                                    </p>
                                                </div>
                                            </>
                                            :
                                            <div className='col-4'>
                                                <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                    Identity proof
                                                </p>
                                                <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>

                                                    {nominee.guardian_id_proof_number || "-"}
                                                </p>
                                            </div>
                                        }
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                    :
                    <div className='e-bg-magnolia border-radius-8 p-5'>
                        <div className='row  '>
                            <div className='justify-content-center  align-items-center d-flex e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>No data found</div>
                        </div>
                    </div>
                }
            </div>

            {/* Autopay details */}
            <div>
                <h6 className='mb-3 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                    Autopay details
                </h6>

                {props.data.mandate_details && props.data.mandate_details.length !== 0 ?
                    <div className='d-flex flex-column gap-2'>
                        {props.data.mandate_details.map((mandate, index) => (
                            <div key={index} className='e-bg-magnolia border-radius-8 p-3'>
                                <div className='row pb-4'>
                                    <div className='col-4'>
                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                            Status
                                        </p>
                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                            {mandate?.status || "-"}
                                        </p>
                                    </div>
                                    <div className='col-4'>
                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                            Type
                                        </p>
                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                            {mandate.type ? mandate.type : "-"}
                                        </p>
                                    </div>
                                    <div className='col-4'>
                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                            Payment frequency
                                        </p>
                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                            Monthly
                                        </p>
                                    </div>

                                </div>

                                <div className='row'>
                                    <div className='col-4'>
                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                            Payment amount
                                        </p>
                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                            {mandate.mandate_limit}
                                        </p>
                                    </div>
                                    <div className='col-4'>
                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                            Next payment date
                                        </p>
                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                            {mandate.next_sip_date ? mandate.next_sip_date : "-"}
                                        </p>
                                    </div>
                                    <div className='col-4'>
                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                            Linked account
                                        </p>
                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                            {mandate.bank_name}
                                        </p>
                                    </div>
                                </div>
                                <div className='row pt-4'>
                                    <div className='col-4'>
                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                            Mandate ID
                                        </p>
                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                            {mandate.mandate_id}
                                        </p>
                                    </div>

                                    <div className='col-4'>
                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                            FP mandate status
                                        </p>
                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                            {mandate.status_text || "-"}
                                        </p>
                                    </div>

                                    <div className='col-4'>
                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                            Created
                                        </p>
                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                            {mandate.created_at || "-"}
                                        </p>
                                    </div>
                                </div>

                                <div className='row pt-4'>
                                    <div className='col-4'>
                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                            Cancelled
                                        </p>
                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                            {mandate.cancelled_at || "-"}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    :
                    <div className='e-bg-magnolia border-radius-8 p-5'>
                        <div className='row  '>
                            <div className='justify-content-center  align-items-center d-flex e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>No data found</div>
                        </div>
                    </div>
                }
            </div>

            {/* Status modal */}
            {checkStatus === true &&
                <CheckStatusModal type={2}
                    title="KYC Status"
                    data={kycStatusData}
                    handleSuccess={() => {
                        setTimeout(() => {
                            setCheckStatus(false);
                            setKycStatusData(null);
                        }, 200);
                    }}
                />
            }
        </div>
    )
}

export default Profile;